import {Component, OnInit} from '@angular/core';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {imprintTemplate} from '../../../../assets/legal-notice/imprint';

@Component({
    selector: 'scitis-legal-notice-modal',
    templateUrl: './legal-notice-modal.component.html',
    styleUrls: ['./legal-notice-modal.component.scss'],
    standalone: false
})
export class LegalNoticeModalComponent implements OnInit{

  closeButtonText: string = '';
  imprintContent: string = '';

  constructor(private activeModal: NgbActiveModal,
              private translateService: TranslateService) {
    this.closeButtonText = this.translateService.instant('Close');
  }

  ngOnInit() {
    this.imprintContent = imprintTemplate;
  }

  onClose() {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

}
